import React, { useState } from 'react';
import { Modal, Button, Form, Input, Select, DatePicker, List, Row, Col, Divider } from 'antd';
import dayjs from 'dayjs';
const ArretPretModal = ({ visible, onCancel, onOk, pretDetails = {} }) => {
  const [form] = Form.useForm();
  const [showNbReportEch, setShowNbReportEch] = useState(false); // État pour contrôler l'affichage du champ

  const formatNumberSeparator = (number) => {
    return number ? number.toLocaleString() : 'N/A'; // Gestion des cas où les nombres ne sont pas disponibles
  };

  const translateEtat = (etat) => {
    switch (etat) {
      case 'Stopped':
        return 'Interrompu';
      case 'Pending':
        return 'En Cours';
      case 'End':
        return 'Arrêté';
      case 'Report':
        return 'Reporté';
      default:
        return etat; // Retourne la valeur d'origine si elle n'est pas trouvée
    }
  };

  // Fonction appelée lorsqu'un motif est sélectionné
  const handleMotifChange = (value) => {
    if (value === 'Report') {
      setShowNbReportEch(true);  // Afficher le champ si le motif est "REPORT"
      form.setFieldsValue({ nb_report_ech: 1 }); // Initialiser le champ à 1 si REPORT
    } else {
      setShowNbReportEch(false); // Cacher le champ pour d'autres motifs
      form.setFieldsValue({ nb_report_ech: undefined }); // Réinitialiser le champ
    }
  };

  // Gestion du formulaire avec onFinish
  const onFinish = (values) => {
    if (values.nb_report_ech === undefined && showNbReportEch) {
      values.nb_report_ech = 1; // S'assurer que nb_report_ech est 1 si non défini et le champ est visible
    }
    onOk(values);
    form.resetFields(); // Réinitialiser les champs
    setShowNbReportEch(false);
    onCancel();
  };

  const handleArretModalCancel = () => {
    form.resetFields(); // Réinitialiser les champs
    setShowNbReportEch(false);
    onCancel(); // Fermer le modal
  };
  return (
    <Modal
      width={800}
      title={`Arrêt du prêt - ${pretDetails ? `${pretDetails.matrisal} ${pretDetails.prenoms} ${pretDetails.nom}` : ''}`}
      visible={visible}
      onCancel={handleArretModalCancel}
      onOk={() => form.submit()}
      footer={[
        <Button key="cancel" onClick={handleArretModalCancel}>
          Annuler
        </Button>,
        <Button key="submit" type="primary" onClick={() => form.submit()}>
          Valider
        </Button>,
      ]}
    >
      <Form form={form} layout="vertical" onFinish={onFinish} initialValues={{ nb_report_ech: showNbReportEch ? 1 : undefined }}>
        <Row gutter={16}>
          <Divider orientation="left"><strong>Prêt</strong></Divider>
          <Col span={12}>
            <List size="small" bordered>
              <List.Item style={{ display: "flex", justifyContent: "space-between" }}>
                <strong>Prêt : </strong>
                <strong>{pretDetails?.code || ""} {pretDetails?.libelle || ""}</strong>
              </List.Item>
              <List.Item style={{ display: "flex", justifyContent: "space-between" }}>
                <strong>Montant du prêt : </strong>
                <strong>{formatNumberSeparator(pretDetails?.montant_pret || "")}</strong>
              </List.Item>
              <List.Item style={{ display: "flex", justifyContent: "space-between" }}>
                <strong>Montant restant dû : </strong>
                <strong>{formatNumberSeparator(pretDetails?.capital_du || "")}</strong>
              </List.Item>
            </List>
          </Col>
          <Col span={12}>
            <List size="small" bordered>
              <List.Item style={{ display: "flex", justifyContent: "space-between" }}>
                <strong>Etat : </strong>
                <strong>{translateEtat(pretDetails?.etat || "")}</strong>
              </List.Item>
              <List.Item style={{ display: "flex", justifyContent: "space-between" }}>
                <strong>Prochaine Échéance : </strong>
                <strong>{pretDetails?.prochain_echeance ? dayjs(pretDetails.prochain_echeance).format('DD/MM/YYYY') : ''}</strong>

              </List.Item>
              <List.Item style={{ display: "flex", justifyContent: "space-between" }}>
                <strong>Nombre Échéances restantes : </strong>
                <strong>{formatNumberSeparator(pretDetails?.nb_mois_restant || "")}</strong>
              </List.Item>
            </List>
          </Col>
        </Row>
        <Divider orientation="left"><strong>Décision d'arrêt</strong></Divider>

        <Form.Item name="motif_arret_pret" label="Motif d'arrêt" rules={[{ required: true, message: 'Veuillez sélectionner un motif' }]}>
          <Select placeholder="Sélectionnez un motif" onChange={handleMotifChange}>
            <Select.Option value="Solde">SOLDE</Select.Option>
            <Select.Option value="Report">REPORT</Select.Option>
            <Select.Option value="Rallonge">RALLONGE</Select.Option>
            <Select.Option value="Erreur">ERREUR</Select.Option>
            <Select.Option value="Depart">DEPART</Select.Option>
            <Select.Option value="Deces">DECES</Select.Option>
          </Select>
        </Form.Item>

        {showNbReportEch && (
          <Form.Item name="nb_report_ech" label="Nombre de reports d'échéances" initialValue={1} rules={[{ required: true, message: 'Veuillez saisir le nombre de reports' }]}>
            <Input type="number" min={1} />
          </Form.Item>
        )}

        <Form.Item name="date_arret_pret" label="Date d'arrêt" rules={[{ required: true, message: 'Veuillez sélectionner une date' }]}>
          <DatePicker
            format="DD/MM/YYYY"
            style={{ width: '100%' }}
            disabledDate={(current) => current && current > dayjs().endOf('day')}
          />
        </Form.Item>
        <Form.Item name="observation" label="Observation" rules={[{ required: true, message: 'Veuillez ajouter une observation' }]}>
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ArretPretModal;

//export default ArretPretModal;
